
import { Component } from "nuxt-property-decorator";
import LoadingSpinner from "~/components/molecules/display/LoadingSpinner.vue";
import PelletsChartTooltip from "~/components/molecules/display/pellets/PelletsChartTooltip.vue";
import PelletsChartBase, {
  PELLETS_CHART_COLORS,
  PelletsChartTheme,
} from "~/mixins/PelletsChartBase";

@Component({
  components: { LoadingSpinner, PelletsChartTooltip },
})
export default class PelletsChartOverview extends PelletsChartBase {
  get chartTheme(): PelletsChartTheme {
    const isMobile = this.viewportWidth < 700;
    const isSmallMobile = this.viewportWidth < 420;

    return {
      ...PELLETS_CHART_COLORS,
      axis: {
        fontSize: 12,
        fontWeight: "500",
        color: "#747474",
      },
      yAxis: {
        beginAtZero: false,
        stepSize: 5,
        grace: "8%",
      },
      pointRadius: 3,
      xAxisMaxTicks: isSmallMobile ? 4 : 6,
      legend: {
        pointStyleWidth: isMobile ? 15 : 25,
        fontSize: isMobile ? 12 : 16,
      },
      layout: {
        aspectRatio: isMobile ? 1.5 : undefined,
        maintainAspectRatio: isMobile,
      },
    };
  }
}
